export enum EFormFields {
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    DATE_OF_BIRTH = 'birthdate',
    MARKETING = 'hasAgreedToReceiveMarketing'
}
